<template>
	<div class="page" data-name="payment-list">
		<div class="page-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					자녀학습 현황
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div style="padding:8px;">
				<button class="button button-outline float-right" style="width:unset; line-height: 1;" @click="openAddChildPopup()">
					<i class="f7-icons" style="vertical-align:middle">plus</i>
					<span style="vertical-align:middle">자녀 등록</span>
				</button>
			</div>
			
    	<f7-block-title>
				<span>등록된 자녀 목록</span>
			</f7-block-title>

			<div class="list">
				<ul>
					<template v-for="(item, i) in childList">
						<li :key="'ii' + i">						
							<div class="item-content item-inner">
								<div class="item-title">
									<div class="item-header">
										{{getStatus(item.USER_STATUS)}}
										<small style="margin-left:5px">만료일 : {{getDate(item.AUTH_EXP_DATE)}}</small>
									</div>	
									{{getContent(i)}}		
									<span class="badge color-red" v-if="checkExpireDate(item.AUTH_EXP_DATE)" v-on:click="goOnlineList()">기간연장필요</span>																	
								</div>
								<div class="item-after item-link">																
									<span class="badge color-gray" v-on:click="deleteChild(i)">등록해제</span>
								</div>
							</div>					
						</li>
					</template>
				</ul>
			</div>

			<f7-block-title>
				<span>자녀 학습 월간현황</span>
			</f7-block-title>
			<div class="row" style="padding:4px">
				<div class="wide-border-box col-200 xsmall-200 small-200 medium-120 large-120 xlarge-120" style="height:300px;">
					<canvas class="total-month-chart" ref="totalMonthChart" style="width:100%; height:100%;"></canvas>
				</div>			
			</div>

		</div>
	</div>
</template>

<style lang="scss" scoped>

.wide-border-box {
	border-radius: 4px;
	border: solid 1px #ddd;
	background-color: #fff;
	padding: 12px;
	margin: 4px;
}

</style>


<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import Chart from 'chart.js';

export default {
	data() {
		return {
			childList: []
		}
	},
	mounted() {
		const _this = this;
		_this.loadMyChildList();
		_this.renderTotalMonthChart();
	},
	methods: {

		goOnlineList() {
			const _this = this;
			var param = {};
			var url = PAGES.MENU_PAYMENT_ONLINE_LIST;

			PAGES.goPage(url,param);
		},
		checkExpireDate(authExpDate){
			const _this = this;
			var check = false;		
			var nowDate = moment({ h: 0, m: 0, s: 0, ms: 0 });
			var _theDate = moment(authExpDate);
			var theDate = moment({
				year: _theDate.year(),
				month: _theDate.month(),
				day: _theDate.date()
			});

			var duration = moment.duration(theDate.diff(nowDate)).asDays();
			
			if(duration <= 7) {
				check = true;
			}
			
			return check;						
		},
		renderTotalMonthChart() {
				var _this = this;

				var chartConfig = {
					type: 'line',
					data: {
						labels: ['7월', '8월', '9월', '10월', '11월', '12월'],
						datasets: [
							{
								label: '시험점수',
								yAxisID: 'student',
								data: [38, 62, 68, 75, 100, 88],
								backgroundColor: '#00ffaaa0',
								borderColor: '#00ffaaff',
								borderWidth: 2,
								fill: false,
							},
							{
								label: '평균점수',
								yAxisID: 'study',
								data: [70, 80, 95, 79, 89, 90],
								backgroundColor: '#00aaffa0',
								borderColor: '#00aaffff',
								borderWidth: 2,
								fill: true,
							}
						]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						title: {
							display: false,
							text: ''
						},
						tooltips: {
							mode: 'index',
							intersect: false,
						},
						hover: {
							mode: 'nearest',
							intersect: true
						},
						legend: {
							display: true,
							position: 'top',
							align: "end"
						},
						scales: {
							xAxes: [{
								display: true,
								scaleLabel: {
									display: false,
									labelString: '월'
								}
							}],
							yAxes: [{
								id: 'student',
								display: true,
								position: 'left',
								type: 'linear',
								ticks: {
									precision: 0,
									fontColor: '#00ffaaff'
								},
								scaleLabel: {
									display: false,
									labelString: '학생수'
								}
							},{
								id: 'study',
								display: true,
								position: 'right',
								type: 'linear',
								ticks: {
									precision: 0,
									fontColor: '#00aaffff'
								},
								scaleLabel: {
									display: false,
									labelString: '학습총량'
								}
							}]
						}
					}
				};

				var ctx = _this.$refs.totalMonthChart.getContext('2d');
				var chartObj = new Chart(ctx, chartConfig);
		},
		getDate(day) {
			const _this = this;
			var thisDate = moment(day).format("YYYY-MM-DD");		
		
			return thisDate;
		},
		getContent(itemIndex) {
			const _this = this;
			var item = _this.childList[itemIndex];
			var content = "";
			
			content += item.USER_NAME;
			content += "("+CONST.gradeMap[item.USERGRADE_ID].name+")";
			//content += "생년월일 : " + _this.getDate(item.BIRTH_DATE);

			return content;
		},
		getStatus(statusId) {
			const _this = this;
			var descript = CONST.userStatus[statusId].descript;
			return descript;
		},
		openAddChildPopup() {
			const _this = this;
			_this.$f7.dialog.prompt("등록할 자녀의 코드를 입력", "안내", function (code) {
				
				if(MODULE.Util.isEmpty(code)) {
					MODULE.DialogBox.message("코드를 입력하세요.");
					return;
				}

				_this.addChild(code);
			});

		},
		addChild(childCode) {
			const _this = this;
			
			var childKey = MODULE.Util.d32Tod10(childCode);

			if(childKey == 0 || childKey == undefined || childKey == null){
				MODULE.DialogBox.message("잘못된 코드입니다.");
				return;
			}

			let param = {
				pChildKey : childKey
			}

			API.ajaxRequest({
				url : API.addChildUrl(),
				data: param
			}).then(function(data) {
				_this.loadMyChildList();
			}).catch(function(code) {
				
				if(code == CONST.resultCode.NOT_FOUND) {
					MODULE.DialogBox.message("자녀정보가 없습니다.");
				}else if(code == CONST.resultCode.NOT_EMPTY) {
					MODULE.DialogBox.message("이미 등록된 자녀입니다.");
				}else{
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				}

			});
			
		},
		deleteChild(itemIndex) {
			const _this = this;

			MODULE.DialogBox.okcancel(
				"확인",	"자녀 등록을 해제 하시겠습니까?",
			
				function() {
					var item = _this.childList[itemIndex];

					if(item.CHILD_KEY == 0){
						MODULE.DialogBox.message("자녀정보가 없습니다.");
						return;
					}
						
					let param = {
						pChildKey : item.CHILD_KEY
					}

					API.ajaxRequest({
						url : API.deleteChildUrl(),
						data: param
					}).then(function(data) {
						_this.loadMyChildList();
					}).catch(function(code) {
						MODULE.UITool.catchBlock(code, PAGES, AUTH);
					});

				}
			);

		},
		loadMyChildList() {
			const _this = this;

			let param = {};
			
			API.ajaxRequest({
				url: API.getMyChildListUrl(),
				data: param
			}).then(function(data) {  
				_this.childList = data.childList;
			}).catch(function(code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		
		}

	}
}
</script>